const token = (function () {
  const store = {
    accessToken: null,
    expiresAt: 0,
  };

  return {
    get accessToken() {
      return this.isValid ? store.accessToken : null;
    },
    get isValid() {
      const { accessToken, expiresAt } = store;
      if (!accessToken || !expiresAt) return false;

      const diff = expiresAt - Date.now();
      return diff > 0;
    },
    store() {
      return store;
    },
    reset() {
      store.accessToken = null;
      store.expiresAt = 0;
    },
    refresh({
      accessToken, expiresAt, expiresIn, createdAt,
    }) {
      if (!expiresAt) {
        expiresAt = (createdAt + expiresIn) * 1000;
      }

      store.accessToken = accessToken;
      store.expiresAt = expiresAt;
    },
    toString() {
      return this.accessToken;
    },
    toJSON() {
      return this.accessToken;
    },
  };
}());

export default token;
